import axiosClient from "./axiosClient";

const phoneApi = {
  getPhone: async (page: number, limit: number) => {
    const res = await axiosClient.get<any>(
      `/phone-number?page=${page}&limit=${limit}`
    );

    return res.data;
  },
};

export default phoneApi;
